
import "./navbar.css"
import { WalletMultiButton } from "@demox-labs/aleo-wallet-adapter-reactui";


const Navbar = () => {
    return (
        <>
            <WalletMultiButton />

        </>
    )
}
export default Navbar;